function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M0,0H24V24H0ZM0,0H24V24H0ZM0,0H24V24H0ZM0,0H24V24H0Z",
  fill: "rgba(0,0,0,0)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M12,6.5a4.938,4.938,0,0,1,4.76,6.46l3.06,3.06A11.8,11.8,0,0,0,23,11.49,11.838,11.838,0,0,0,8.36,4.57l2.17,2.17A5.14,5.14,0,0,1,12,6.5ZM2.71,3.16a1,1,0,0,0,0,1.41L4.68,6.54A11.892,11.892,0,0,0,1,11.5a11.8,11.8,0,0,0,15.31,6.68l2.72,2.72a1,1,0,1,0,1.41-1.41L4.13,3.16A1.008,1.008,0,0,0,2.71,3.16ZM12,16.5a5,5,0,0,1-5-5,4.911,4.911,0,0,1,.49-2.14l1.57,1.57A3.434,3.434,0,0,0,9,11.5a3,3,0,0,0,3,3,2.694,2.694,0,0,0,.57-.07L14.14,16A4.813,4.813,0,0,1,12,16.5Zm2.97-5.33a2.969,2.969,0,0,0-2.64-2.64Z",
  fill: "#686868"
});

function SvgPasswordNotVisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-action-not_visible",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordNotVisible);
export default __webpack_public_path__ + "static/media/password-not-visible.ad1a2fe2.svg";
export { ForwardRef as ReactComponent };